hrd.charts.DonutChart = hrd.charts.PieChart.extend({
	doChart: function(dynamicOptions){
		this._super(dynamicOptions);

		/* used to format title and sub title in two different lines */
		if(dynamicOptions.innerTitle && dynamicOptions.innerSubTitle){
			let dy = (dynamicOptions.innerSubTitleDeltaY != undefined) ? dynamicOptions.innerSubTitleDeltaY : 30;
			let label = d3.select(`${this.settings.id} text.c3-chart-arcs-title`);
			label.html(''); // remove existant text
			label.insert('tspan').text(dynamicOptions.innerTitle).attr('dy', 0).attr('x', 0).attr('class','donut-title-style');
			label.insert('tspan').text(dynamicOptions.innerSubTitle).attr('dy', dy).attr('x', 0).attr('class','donut-subtitle-style');
		}
	},
	_adaptSpecificChart: function(staticOptions, dynamicOptions){
		staticOptions.donut = {
			expand: dynamicOptions.expand,
			label : {
				show: dynamicOptions.showLabels,
				threshold: dynamicOptions.labelThreshold,
			}
		};
		if(dynamicOptions.width){
			staticOptions.donut.width = dynamicOptions.width;
		}
		if(dynamicOptions.innerTitle){
			staticOptions.donut.title = dynamicOptions.innerTitle;
		}
		if(dynamicOptions.formatPattern){
			staticOptions.donut.label.format = function(v, r){
				return d3locale.format(this.pattern)(this.useRatio ? r : v);
			}.bind({pattern: dynamicOptions.formatPattern, useRatio: dynamicOptions.useRatio});
		}
	}
});